export default __webpack_public_path__ + "static/insta-hotels-7-41f1fb50819be730316f64d2966a6dc3.jpg";